import * as React from 'react';
import { connect } from 'react-redux';
import '../../assets/SmartAdmin/css/app.bundle.css';
import './assets/dashboard.css';
import Navigation from '../Navigation';
import { Link } from 'react-router-dom';
import { UserInfo } from '../Login/common/defaults';
import { logOut } from '../Login/redux-objects/actions';
import { ProgressBar, Modal, ModalBody } from 'react-bootstrap';
import PBITest from '../PowerBI/PBITest';
import PowerBiViewController from '../PowerBI/PowerBiViewController';
import PowerBiCreateReport from '../PowerBI/PowerBiCreateReport';
import Dashboard from '../Dashboard/Dashboard';
import { withRouter } from 'react-router-dom';
import { setShowSidebar } from '../../components/Application/redux-objects/actions';
import BreadCrumb from '../BreadCrumb/BreadCrumb';

export interface IDashboardPropsFromState {
  header: string;
  currentUser: UserInfo;
  showLoading: boolean;
  showSidebar: boolean;
  showHeader: boolean;
  loadingText: string;
  history: any;
}

interface IDashboardPropsFromAction {
  logOut: () => void;
  setShowSidebar?: (showSidebar: boolean) => void;
}

interface IDashboardLocalState {
  showLogout: boolean;
  //showSidebar: boolean;
}

type IDashboardProps = IDashboardPropsFromState & IDashboardPropsFromAction;

const uiBuildVersion =
  process.env.UI_BUILD_VERSION ||
  process.env.BUILD_BUILDNUMBER ||
  process.env.BUILD_NUMBER;
const uiBuildLabel = process.env.UI_BUILD_LABEL || 'Version';

class Layout extends React.Component<IDashboardProps, IDashboardLocalState> {
  constructor(props) {
    super(props);
    this.state = {
      showLogout: false,
    };
  }

  toggleLogout = () => {
    this.setState({ showLogout: !this.state.showLogout });
    const element = document.getElementById('logout');
    element.classList.toggle('fa-chevron-circle-down');
    element.classList.toggle('fa-chevron-circle-up');
  };

  toggleSidebar = () => {
    // this.setState({ showSidebar: !this.state.showSidebar });
    this.props.setShowSidebar(!this.props.showSidebar);
    const element = document.getElementById('hideSidebar');
    element.classList.toggle('fa-angle-double-right');
  };

  render() {
    return (
      <div className='mod-bg-4 mod-hide-info-card desktop chrome webkit pace-done blur'>
        <div className='page-wrapper'>
          <div className='page-inner'>
            {this.props.showSidebar && (
              <aside className='page-sidebar'>
                {this.state.showLogout && (
                  <div className='user-logout'>
                    <Link to='#' onClick={() => this.props.logOut()}>
                      Sign Out
                    </Link>
                  </div>
                )}
                <div className='user-content'>
                  <div className='welcome'>Logged in as</div>
                  <div className='user-name'>
                    {this.props.currentUser.firstName}{' '}
                    {this.props.currentUser.lastName}
                  </div>
                  <i
                    id='logout'
                    className='fas fa-chevron-circle-down float-right logout-icon pointer'
                    onClick={() => {
                      this.toggleLogout();
                    }}
                  >
                    {' '}
                  </i>
                </div>
                <Navigation />
              </aside>
            )}
            <div className='page-content-wrapper'>
              {this.props.showHeader && (
                <header className='page-header' role='banner'>
                  <div>
                    <i
                      id='hideSidebar'
                      className='fa fa-angle-double-left'
                      aria-hidden='true'
                      onClick={() => {
                        this.toggleSidebar();
                      }}
                    >
                      {' '}
                    </i>
                  </div>
                  {/* {this.props.header} */}
                  <BreadCrumb />
                </header>
              )}
              <main className='page-content' role='main' id='js-page-content'>
                {/* {this.props.history.location.pathname == '/' && <Dashboard />} */}
                {this.props.children}
                <Modal
                  show={this.props.showLoading}
                  aria-labelledby='contained-modal-title-vcenter'
                  centered
                >
                  <ModalBody>
                    <h4
                      style={{
                        textAlign: 'center',
                        padding: '10px',
                        fontVariant: 'all-small-caps',
                      }}
                    >
                      {this.props.loadingText}
                    </h4>
                    <ProgressBar
                      animated
                      now={100}
                      style={{ margin: '0 auto', marginBottom: '25px' }}
                    />
                  </ModalBody>
                </Modal>
              </main>
              {uiBuildVersion && (
                <div className='build-version-badge'>
                  {uiBuildLabel} {uiBuildVersion}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    header: reduxState.Navigation.header,
    currentUser: reduxState.Application.currentUser,
    showLoading: reduxState.Application.showLoading,
    loadingText: reduxState.Application.loadingText,
    showSidebar: reduxState.Application.showSidebar,
    showHeader: reduxState.Application.showHeader,
  };
};

const mapDispatchToProps = {
  logOut,
  setShowSidebar,
};

export default withRouter(
  connect<IDashboardPropsFromState, IDashboardPropsFromAction>(
    mapStateToProps,
    mapDispatchToProps
  )(Layout)
);
